import React from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../../../components/Menu/Utils/commonFunctions';
import RawAverageTable from '../../../../../components/Table/RawAverageTable';
import Tabs from '../../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../../constants/permissionsEnum';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';

const RawMaterials: React.FC<{
  selectedYear: string;
}> = ({selectedYear}) => {
  const ElectricityTab = [
    {
      id: 'rawAverage',
      name: <TranslatedText translationKey="Average" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <RawAverageTable selectedYear={selectedYear} isAverage={true} />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerProductRawMaterialAverage
      )
    },
    {
      id: 'rawSupplier',
      name: <TranslatedText translationKey="Supplier Specific" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <RawAverageTable selectedYear={selectedYear} isAverage={false} />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerProductRawMaterialSupplierSpecific
      )
    }
  ].filter((item) => !item.hidden);

  return <Tabs array={ElectricityTab} type="card" />;
};

export default RawMaterials;
